import md5 from "md5"
import {RequestAccessSecret} from "@/utils/constant";
export const getSign = (string) => {

  return md5(string+RequestAccessSecret.toString())
}
export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}


export const cutText = (str, maxLen = 50) => {
  // 如果为空直接返回空字符串
  if (!str) return ''
  // 转字符串，防止数字/对象报错
  const text = String(str)
  // 超出长度就截取 + ...
  if (text.length > maxLen) {
    return text.slice(0, maxLen) + '...'
  }
  // 没超出直接返回
  return text
}